













































































































import Component from 'vue-class-component';
import { ISearchBody } from '@/entities/search-body.interface';
import { IPaging } from '@/entities/paging.interface';
import { IAgentListItem } from '@/entities/agents/agent-list-item.interface';
import agentsApi from '@/api/agents.api';
import { MasterPageCriteria } from '@/components/base/master/master-page-criteria';
import { ISort } from '@/entities/sort.interface';
import { IConfirm } from '@/entities/confirm.interface';
import * as types from '@/store/types';
import { IUpdateStatus } from '@/entities/update-status.interface';
import { mapGetters } from 'vuex';
import BlackListIpsCriteriaComponent from '@/containers/account/black-list-ip/criteria/black-list-ips-criteria.vue';
import {IBlackListIpListItem} from '@/entities/black-list-ips';
import blackListIpsApi from '@/api/black-list-ips.api';

@Component({
    components: {
        'app-black-list-ips-criteria': BlackListIpsCriteriaComponent
    },
    computed: mapGetters({
        superAdminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS
    })
})
export default class IBlackListIpMasterPage extends MasterPageCriteria {
    public items: IBlackListIpListItem[] = [];

    protected defaultSort: ISort = {
        field: 'id',
        asc: true
    };

    public list(body: ISearchBody): Promise<IPaging<IBlackListIpListItem>> {
        return blackListIpsApi.list(body);
    }

    public deleteIp(item: IBlackListIpListItem) {
        blackListIpsApi.delete(item.id);
        this.search();
    }
    public deleteSelected() {
        this.deleteSelectedBatch(
            'Are you sure to delete selected IP?'
        );
    }

    private async deleteSelectedBatch(
        alertText: string
    ) {
        let afterFn = async (closeFn: () => void) => {
            const ids = [...this.selected];
            this.selected = [];

            try {
                ids.forEach( (id) => {
                     blackListIpsApi.delete(id);
                });
            } finally {
                closeFn();
                await this.search();
            }
        };

        let payload: IConfirm = {
            heading: alertText,
            afterFn
        };

        await this.$store.dispatch(types.SHOW_CONFIRM, payload);

    }

}
